import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import collection from './modules/collection'
import products from './modules/products'
import productPage from './modules/productPage'
import swatchColors from './modules/swatchColors' 

Vue.use(Vuex)

const state = {}

export default new Vuex.Store({
    state,
    modules: {    
        cart,
        collection,
        products,
        productPage,
        swatchColors
    }
})